import React from 'react';

import Image from '../Image';
import InternalExternalLink from '../Link';

import { Integration as IntegrationInterface } from '../../interfaces/integration';

function Integration({
  size,
  integrationType,
  image,
  integration,
  category,
  link,
}: IntegrationInterface) {
  const WrapperComponent = link ? InternalExternalLink : 'div';

  return (
    <WrapperComponent
      className={`cl-integration cl-integration--${size} cl-integration--${integrationType}`}
      link={link}
      aria-label={link ? 'integration link' : ''}
    >
      <div className='cl-integration__image'>
        <Image data={image} />
      </div>

      {(integration || category) && (
        <div className='cl-integration__text'>
          {integration && <h3 className='cl-integration__title'>{integration}</h3>}
          {category && <h6 className='cl-integration__category'>{category.toUpperCase()}</h6>}
        </div>
      )}
    </WrapperComponent>
  );
}

export default Integration;
